import {ColumnStore} from "@bryntum/schedulerpro";
import {WIDGET_KEYS} from "../../other/constants/WidgetKeys.jsx";
import {EntityMainNameDefault, lineThroughRenderer} from "../../other/utils/utils.jsx";
import SwivuSortColumn from "./SwivuSortColumn.jsx";

export default class EntityMainNameColumn extends SwivuSortColumn {
  static get $name() {
    return "EntityMainNameColumn";
  }

  static get type() {
    return WIDGET_KEYS.columnEntityMainName;
  }

  static get defaults() {
    return {
      editor: false,
      align: "left",
    };
  }

  defaultRenderer({ record }) {
    return EntityMainNameDefault(lineThroughRenderer(record[this.field], record.archived));
  }
}

ColumnStore.registerColumnType(EntityMainNameColumn);
